// eslint-disable-next-line import/prefer-default-export
export const darkPrimary = 'rgb(11, 49, 68)';
